import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AddMasterTempCategoryComponent } from 'src/app/middleware/common/addMasterTempCategory/addMasterTempCategory.component';
import { MasterTemplateCategory } from '../services/settingService/setting.enum';

@Component({
  selector: 'app-manage-SystempPrompttemplate',
  templateUrl: './manage-Systemprompt.component.html',
  styleUrls: ['./manage-Systemprompt.component.scss']
})
export class ManageSystemPromptsTemplateComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  value = '';
  filterText: any;   
  totalCount: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  selectedCategoryID:number=0;
  ShowNoRecordFound:boolean=false;
  sysPromptList: any[] = [];
  masterTemplateList: any[] = [];
  categoryName:string="";
  SystemPromptID:number=0;
  msg: string = "";
  systemPrompt: string = "";
  title:string="Add Email Template";
  button:string="Save";
   promptTitle:string="";
   public editorConfig = {
    versionCheck: false
  };
   promptType: number = 0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {    
    this.getSystemPromptTemplateList();
  }

   // For Get All Template List
   getSystemPromptTemplateList(){
    var ReqModel={  
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
     this.loaderService.show();
     this.settingsService.GetAllSystemPrompt().subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {           
            this.sysPromptList=this.responseHolder.data;                 
              if(this.sysPromptList.length>0){              
                this.ShowNoRecordFound=false;
             }else{
              this.ShowNoRecordFound=true;
          } 
         }else{
          this.loaderService.hide();
         }
       }else{
        this.loaderService.hide();
       }
     });
   }
   
    //For  Open Pop (Add Email Temp)
     openDialogAdd(templateRef: TemplateRef<any>) {
      this.systemPrompt="";
      this.msg="";
      this.promptTitle="";
      this.title="Add System Prompt test";
      this.button="Save";   
      this.SystemPromptID=0;
      this.AddEditButton=false;
      this.dialog.open(templateRef, {
        width: '90%',
        height: '90%',
      });
     }

   //For  Open Pop (Update Email Temp)
   openDialogUpdateType(templateRef: TemplateRef<any>, type: any) {  
    this.SystemPromptID=type.systemPromptID;
    this.title="Update System Prompt";
    this.button="Update";
    this.AddEditButton=false;
    this.getDetails(type.systemPromptID)
    this.dialog.open(templateRef, {
      width: '90%',
      height: '90%',
    });
   }
 
   getDetails(systemPromptID){
    var ReqModel={
      systemPromptID: systemPromptID,     
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
     }
     this.loaderService.show();
     this.settingsService.GetSystemPromptByID(ReqModel).subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {          
          this.promptTitle=this.responseHolder.data.systemPromptTitle;
          this.systemPrompt=this.responseHolder.data.systemPrompt;
          this.promptType = this.responseHolder.data.type;
         }else{
          this.loaderService.hide();
         }
       }else{
        this.loaderService.hide();
       }
     });
   }

    // For Add Email Template name
    AddUpdateSystemPrompts() {
      if(this.promptTitle == "" && this.systemPrompt=="") {
        this.toastr.warning('Please enter prompt title and system prompt both.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.spinner=true;
      this.AddEditButton=true;
      var ReqModel = {
          systemPromptID: this.SystemPromptID,
          SystemPromptTitle: this.promptTitle,
          type:this.promptType,
          SystemPrompt: this.systemPrompt,
          userId: this.currentUser.UID,
          //isPublic:true,
          organizationID: Number(this.organizationId),
          //officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),

      }
      this.settingsService.AddUpdateSystemPrompts(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.spinner=false;      
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess){
            this.dialog.closeAll();
            this.getSystemPromptTemplateList();
            if(this.SystemPromptID==0){
              this.toastr.success('System prompt added successfully.', '', {
                timeOut: 3000,
              });
            }else{
              this.toastr.success('System prompt updated successfully.', '', {
                timeOut: 3000,
              });
            }           
          }else{
            this.toastr.warning('System prompt title already exist.', '', {
              timeOut: 2000,
            });
            this.AddEditButton=false;
            this.spinner=false;         
          }
        }else{
          this.AddEditButton=false;
          this.spinner=false;       
        }
      });
     }


   // For Delete Category
   DeleteSystemPrompt(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel = {
          SystemPromptID: type.systemPromptID,        
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
        }     
        this.settingsService.DeleteSystemPrompt(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.getSystemPromptTemplateList();
              this.toastr.success('System prompt deleted successfully.', '', {
                timeOut: 3000,
              });
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }
   

   close() {
    this.dialog.closeAll();
   }


   Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.searchValue = filterValue.trim();
   }

   clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText.trim();
    }
 
    showSignature:boolean=false;
    AddEditButton:boolean=false;

    ckEditorConfig: any = {
      toolbar: [
        ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
        ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
        ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
        ['Link', 'Unlink', 'Anchor'],
        ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['TextColor', 'BGColor'],
        ['Maximize', 'ShowBlocks']
      ]
    };

  //  CheckMessage(val) {    
  //   if (this.subject != "" && this.msg != "") {
  //     this.AddEditButton=false;
  //   } else {
  //     this.AddEditButton = true;
  //   }
  // }

  // CheckSubject(val) {    
  //   if (this.subject != "" && this.msg != "") {
  //     this.AddEditButton=false;
  //   } else {
  //     this.AddEditButton = true;
  //   }
  // }

}
